/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../common-services/user/user.service';

@Component({
  selector: 'vc-view-images',
  templateUrl: './view-images.component.html',
  styleUrls: ['./view-images.component.scss']
})

export class ViewImagesComponent implements OnInit {

  imageGallery = [];
  allImages = [];
  currentIndex = 0;
  imageDisplay: any;
  isListDisplay: any;
  currentImages = [];
  imageURL: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public userService: UserService, public matDialogReference: MatDialogRef<ViewImagesComponent>) {}

  ngOnInit() {
    console.log(this.data);
    console.log(this.data.productImages);
    if(this.data.productImages) {
      this.imageGallery = this.data.productImages;
      this.imageDisplay = this.data.productImages[0];
      this.allImages = this.data.allImages;
  
      if (this.data.imageURL) {
        this.imageURL = this.data.imageURL;
      } else {
          this.imageURL = 'image';
      }
  
      if (this.data.isListDisplay) {
        this.isListDisplay = this.data.isListDisplay;
      }  
    }
  }

  findIndex(image: any) {
    return this.imageGallery.findIndex(
      element => element[this.imageURL] === image[this.imageURL]
    );
  }

  mainImage(index) {
    this.imageDisplay = this.imageGallery[index];
    this.currentIndex = index;
  }

  getImages(type: string) {
    if (type) {
      this.currentIndex =
        type === 'after' ? this.currentIndex + 1 : this.currentIndex - 1;
      this.imageGallery = this.allImages[this.currentIndex];
      if (this.imageGallery) {
        this.imageDisplay = this.imageGallery[0];
      }
    }
  }

  moveImage(type) {
    if (type === 'left') {
      if (this.imageGallery[this.currentIndex - 1]) {
        this.currentIndex--;
        this.imageDisplay = this.imageGallery[this.currentIndex];
      }
    } else {
      if (this.imageGallery[this.currentIndex + 1]) {
        this.currentIndex++;
        this.imageDisplay = this.imageGallery[this.currentIndex];
      }
    }
  }
  closeViewImages() {
    this.matDialogReference.close();
  }
}